import React from 'react';
import { Button, Card, Carousel, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import noticia1 from '../../assets/noticia1.png';
import noticia2 from '../../assets/noticia2.png';
import noticia3 from '../../assets/noticia3.png';
import noticia4 from '../../assets/noticia4.png';

import dep1 from '../../assets/famahockey.png';
import dep2 from '../../assets/famafutbol.png';

import tema1 from '../../assets/tema1.png';
import tema2 from '../../assets/tema2.png';
import tema3 from '../../assets/tema3-1.png';
import tema4 from '../../assets/tema4.png';
import tema5 from '../../assets/Futbol.png';
import tema6 from '../../assets/Futbol2.png';
import useHome from './useHome';

export const Home: React.FC = () => {
    const {
        handleMessage,
        handleNavigation,
    }=useHome();
    

    const noticias: string[] = [noticia1, noticia2, noticia3, noticia4];
    const deportes = [
        {
            img: dep1,
            texto: "Divisiones inferiores, primera, reserva y mamis de hockey. actualmente participando de la ASOCIACION TUCUMANA DE HOCKEY AMATEUR"
        },
        {
            img: dep2,
            texto: "Divisiones inferiores de futbol. Participando en LA LIGA TUCUMANA DE FUTBOL, con las categorias : 2009, 2008, 2007, 2006. dts Oscar Colo Medina y Carlos cabral, PF Maria Rivero"
        }
      ];

    return (
        <div className="container">
            {/* Carousel solo en móvil */}
            <div className="d-md-none mb-4 mt-1">
                <Carousel>
                {noticias.map((img, i) => (
                    <Carousel.Item key={i}>
                        <img className="d-block w-100" src={img} alt={`Noticia ${i + 1}`} />
                    </Carousel.Item>
                ))}
                </Carousel>
            </div>

            {/* Noticias en fila para escritorio */}
            <div className="row d-none d-md-flex rowNoticias mb-4">
                {noticias.map((img, i) => (
                <div className="col-6 col-md-3 mb-3 text-center" key={i}>
                    <img src={img} alt={`Noticia ${i + 1}`} className="img-fluid rounded" />
                    <div className="lbNoti mt-2">
                    <label className="fw-bold">Título de la Noticia {i + 1}</label>
                    </div>
                </div>
                ))}
            </div>

            {/* Deportes */}
            <div className="divDeportes mb-5">
                <h4 className="mb-4" style={{fontWeight:'600'}}>Deportes</h4>
                <Row>
                {deportes.map((img, i) => (
                    <Col xs={12} md={6} className="mb-3" key={i}>
                    <Card>
                        <Card.Img variant="top" src={img.img} className="img-fluid" />
                        <Card.Body>
                        <Card.Text>
                                {img.texto}
                        </Card.Text>
                        </Card.Body>
                    </Card>
                    </Col>
                ))}
                </Row>
            </div>

            {/* Botón divisor */}
            <div className="divisor text-center mb-5">
                <Button className="btnDivisor" onClick={() => handleMessage()}>
                    Plantel Fútbol Profesional
                </Button>
            </div>

            {/* Temas */}
            <div className="temas mb-5">
                <Row className="mb-4">
                    <Col xs={12} md={6} className="mb-3" onClick={()=>{handleNavigation('/historia')}} style={{cursor:'pointer'}}>
                        <h5>Historia del club</h5>
                        <img src={tema1} alt="Historia" className="img-fluid rounded" />
                    </Col>
                    <Col xs={12} md={6} className="mb-3" onClick={()=>{handleNavigation('/comision')}} style={{cursor:'pointer'}}> 
                        <h5>Comisión directiva</h5>
                        <img src={tema2} alt="Comisión" className="img-fluid rounded"  style={{height:'170px'}}/>
                    </Col>
                </Row>
                <Row className="mb-4">
                <Col xs={12} md={6} className="mb-3">
                    <h5>Logros</h5>
                    <img src={tema3} alt="Logros" className="img-fluid rounded" />
                </Col>
                <Col xs={12} md={6} className="mb-3">
                    <h5>Eventos recreativos</h5>
                    <img src={tema4} alt="Eventos" className="img-fluid rounded" />
                </Col>
                </Row>
                <Row>
                <Col xs={12} md={6} className="mb-3">
                    <div className="position-relative text-white">
                    <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center">
                        <h5 className="text-center">Reviví los<br />partidos de fútbol</h5>
                    </div>
                    <img src={tema5} alt="Fútbol" className="img-fluid rounded" />
                    </div>
                </Col>
                <Col xs={12} md={6} className="mb-3">
                    <div className="position-relative text-white">
                    {/* <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center">
                        <h5 className="text-center">Reviví los<br />partidos de fútbol</h5>
                    </div> */}
                        <img src={tema6} alt="Comisión 2" className="img-fluid rounded" />
                    </div>
                    
                </Col>
                </Row>
            </div>
        </div>
    );
};
